import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { FichaAdicionalOGPPage } from './ficha-adicional-ogp.page';

const routes: Routes = [
  {
    path: '',
    component: FichaAdicionalOGPPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [FichaAdicionalOGPPage]
})
export class FichaAdicionalOGPPageModule {}
